/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Signal_Rates_TitleInputs */

const en_landing_signal_rates_title = /** @type {(inputs: Landing_Signal_Rates_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gilt curve steepens`)
};

/**
* | output |
* | --- |
* | "Gilt curve steepens" |
*
* @param {Landing_Signal_Rates_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_signal_rates_title = /** @type {((inputs?: Landing_Signal_Rates_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Signal_Rates_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_signal_rates_title(inputs)
});